import { Inputs } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import InformationContainer from 'Containers/Result/components/InformationContainer';
import ChatBoxButton from 'Containers/Result/components/ChatBoxButton';
import CustomTransition from 'Components/CustomTransition';
import OneColLayout from 'Components/Layouts/OneColLayout';
import * as Styled from './styles';
import { ViewProps } from './types';
import ResultBox from './components/ResultBox';

const Result = ({ data, onClick }: ViewProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  const wizardOptions = [
    { id: '1', label: t('result:Result.step.one'), value: 1 },
    { id: '2', label: t('result:Result.step.two'), value: 2 },
    { id: '3', label: t('result:Result.step.three'), value: 3 },
  ];
  return (
    <OneColLayout>
      <CustomTransition start>
        <Styled.Container
          type={data?.taxReturnType}
          direction="column"
          align="center"
          gap="dimension_24"
        >
          <Styled.WizardBox>
            <Inputs.Wizard options={wizardOptions} value={1} />
          </Styled.WizardBox>
          <ResultBox data={data} onClick={onClick} />
          <InformationContainer data={data} />
          <ChatBoxButton />
        </Styled.Container>
      </CustomTransition>
    </OneColLayout>
  );
};

export default Result;
